import { render, staticRenderFns } from "./RouterPage.vue?vue&type=template&id=5fd4ec32&"
import script from "./RouterPage.vue?vue&type=script&lang=js&"
export * from "./RouterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports